(() => {
  if (window.monolithSearchDiscoveryReady) return;
  window.monolithSearchDiscoveryReady = true;
  const close = () => {
    document.querySelectorAll('header predictive-search').forEach(search => {
      search.classList.remove('mns-browse', 'predictive-search-open');
      search.querySelector('input[type="search"]')?.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('search-open');
  };
  const open = input => {
    const search = input.closest('header predictive-search');
    if (!search || input.value.trim()) return;
    search.removeAttribute('results');
    search.classList.add('mns-browse', 'predictive-search-open');
    search.querySelector('.search__content')?.classList.remove('hidden');
    input.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-open');
    const header = search.closest('header');
    document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
    document.documentElement.style.setProperty('--header-bottom-position', Math.round(header.getBoundingClientRect().bottom) + 'px');
  };
  document.addEventListener('focusin', event => {
    if (event.target.matches('header predictive-search input[type="search"]')) open(event.target);
  });
  document.addEventListener('click', event => {
    const input = event.target.closest('header predictive-search input[type="search"]');
    if (input) { open(input); return; }
    if (!event.target.closest('header predictive-search, #cloud-search-results')) close();
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('header predictive-search input[type="search"]')) return;
    event.target.closest('predictive-search').classList.remove('mns-browse');
    if (!event.target.value.trim()) open(event.target);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.activeElement?.blur();
    close();
    setTimeout(close, 0);
  }, true);
  document.addEventListener('keyup', event => { if (event.key === 'Escape') close(); }, true);
})();